import { render, staticRenderFns } from "./Noise.vue?vue&type=template&id=2a9ebea3"
import script from "./Noise.vue?vue&type=script&lang=js"
export * from "./Noise.vue?vue&type=script&lang=js"
import style0 from "./Noise.vue?vue&type=style&index=0&id=2a9ebea3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports